"use strict";

var _toConsumableArray = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _slicedToArray = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var _ownKeys = function ownKeys(o) {
    _ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return _ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = _ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var d3_1 = require("d3");
var AtomAxis_1 = __importDefault(require("../common/AtomAxis"));
var AtomBarChart_1 = require("./AtomBarChart");
/** Default values if not passed into the component */
var defaults = {
  width: 500,
  height: 500,
  padding: 0.2,
  margin: {
    top: 50,
    right: 50,
    bottom: 50,
    left: 50
  },
  legend: false,
  axisColor: 'black'
};
/**
 * The AtomDualAxisBarChart is a standard bar chart with customizable inputs. NOTE: This allows for negative values, but only in the y2 scale.
 * @param data An array of objects, with objects of type datum: { label: string; value: number; color: string; group?: string; format?: fn, classname?: string }.
 * @param y1Label The label value for the first scale, y1
 * @param y2Label The label value for the second scale, y2
 * @param yaxis A boolean to show or hide the axes
 * @param width The width of the container for scale measurements
 * @param height The height of the container for scale measurements
 * @param padding Padding to include between the bars (from 0 to 1)
 * @param margin Margin to consider with the width and height, as an object with top, bottom, left, and right.
 * @param axisColor A color to pass to the axis component
 * @returns bar chart react component
 */
var AtomDualAxisBarChart = function AtomDualAxisBarChart(_ref) {
  var data = _ref.data,
    y1Label = _ref.y1Label,
    y2Label = _ref.y2Label,
    yaxis = _ref.yaxis,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? defaults.width : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? defaults.height : _ref$height,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? defaults.padding : _ref$padding,
    _ref$margin = _ref.margin,
    margin = _ref$margin === void 0 ? defaults.margin : _ref$margin,
    _ref$axisColor = _ref.axisColor,
    axisColor = _ref$axisColor === void 0 ? defaults.axisColor : _ref$axisColor;
  var groupedData = (0, d3_1.groups)(data, function (d) {
    return d.group || '';
  });
  var grouped = groupedData.length > 1; // grouped bar chart or regular bar chart?
  var groupings = groupedData.map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
      key = _ref3[0];
    return key;
  });
  var labels = Array.from(new Set(data.map(function (d) {
    return d.label;
  })));
  var x0 = (0, d3_1.scaleBand)().domain(groupings).range([margin.left, width - margin.right]).padding(padding);
  var x1 = (0, d3_1.scaleBand)().domain(labels).range([0, x0.bandwidth()]).padding(grouped ? 0.1 : padding);
  var y1Data = data.filter(function (d) {
    return d.label === y1Label;
  }).map(function (d) {
    return d.value;
  });
  var y2Data = data.filter(function (d) {
    return d.label === y2Label;
  }).map(function (d) {
    return d.value;
  });
  var midpoint = (height - margin.top - margin.bottom) / 2;
  /** The y2 scale could be all positive, all negative, or include both positive and negative.
   *  This helps us work our scale and positioning. */
  var y2Scenario = y2Data.reduce(function (t, v) {
    return v > 0 || t;
  }, false) // there are positives
  ? y2Data.reduce(function (t, v) {
    return v < 0 || t;
  }, false) // there are negatives
  ? 'split' : 'positive' : 'negative';
  var y2Domain = y2Scenario === 'positive' ? [0, Math.max.apply(Math, _toConsumableArray(y2Data))] : [Math.min.apply(Math, _toConsumableArray(y2Data)), Math.max.apply(Math, _toConsumableArray(y2Data))];
  var y2Range = y2Scenario === 'positive' || y2Scenario === 'split' ? [height - margin.bottom, margin.top] : [midpoint, margin.top];
  var y2 = (0, d3_1.scaleLinear)().domain(y2Domain).range(y2Range).nice();
  var y1Domain = [0, Math.max.apply(Math, _toConsumableArray(y1Data))];
  var y1Range = y2Scenario === 'positive' ? [height - margin.bottom, margin.top] : y2Scenario === 'negative' ? [midpoint, margin.top] : [y2(0), margin.top];
  var y1 = (0, d3_1.scaleLinear)().domain(y1Domain).range(y1Range).nice();
  var calculatePositon = (0, react_1.useCallback)(function (d) {
    var yScale = d.label === y1Label ? y1 : y2;
    var y, barHeight;
    if (d.label === y2Label) {
      if (d.value == 0) {
        barHeight = 0;
        y = y2Scenario === 'negative' ? midpoint : yScale(0);
      } else if (y2Scenario === 'split' && d.value > 0) {
        barHeight = y1.range()[0];
        y = yScale(d.value);
      } else if (y2Scenario === 'split' && d.value < 0) {
        barHeight = yScale(d.value);
        y = y2(0);
      } else if (d.value > 0) {
        barHeight = y1.range()[0];
        y = yScale(d.value);
      } else if (d.value < 0) {
        barHeight = midpoint + yScale(d.value);
        y = midpoint;
      }
    } else {
      barHeight = y1.range()[0];
      y = yScale(d.value);
    }
    return {
      yScale: yScale,
      y: y,
      barHeight: barHeight
    };
  }, [midpoint, y1, y1Label, y2, y2Label, y2Scenario]);
  return react_1.default.createElement("svg", {
    width: '100%',
    height: '100%',
    viewBox: "0 0 ".concat(width, " ").concat(height)
  }, yaxis && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(AtomAxis_1.default, {
    ticks: y1.ticks(),
    scale: y1,
    orientation: 'left',
    offset: [margin.left, 0],
    color: axisColor
  }), react_1.default.createElement(AtomAxis_1.default, {
    ticks: y2.ticks(),
    scale: y2,
    orientation: 'right',
    offset: [width - margin.right, 0],
    color: axisColor
  })), groupedData.map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      group = _ref5[0],
      data = _ref5[1];
    return react_1.default.createElement("g", {
      key: group,
      transform: "translate(".concat(x0(group) || 0, ", 0)")
    }, data.map(function (d, i) {
      var _calculatePositon = calculatePositon(d),
        y = _calculatePositon.y,
        barHeight = _calculatePositon.barHeight;
      var textAnchor = width > 400 ? undefined : i === 1 ? 'start' : 'end';
      return react_1.default.createElement(AtomBarChart_1.BarGroup, {
        key: "".concat(group, "_").concat(d.label),
        d: d,
        x: x1(d.label) || 0,
        y: y,
        height: barHeight,
        width: x1.bandwidth(),
        textAnchor: textAnchor,
        textColor: axisColor
      });
    }));
  }), react_1.default.createElement(AtomAxis_1.default, {
    ticks: groupings,
    scale: x0,
    orientation: 'bottom',
    offset: [x0.bandwidth() / 2, y1(0)],
    padding: height - y1(0) - margin.bottom + (y2Scenario !== 'positive' ? 15 : 10),
    tickLength: 0,
    color: axisColor,
    domain: true,
    domainLength: width,
    domainMargin: -x0.bandwidth() / 2
  }));
};
exports.default = react_1.default.memo(AtomDualAxisBarChart);